<tyl-kendo-pdf-export [keepTogether]="'.mat-row'" class="tylKendoPdf" [scale]="0.30">
    <div class="flex-header">
        <student-header [showYearSelector]="true" [pageTitle]="'Grades'"></student-header>
    </div>

    <div style="text-align:center;" *ngIf="showGradesMessage">
        {{gradesMessage}}
    </div>

    <tabs *ngIf="tabNames && tabNames.length > 1" [tabNames]="tabNames" (selectionsChange)="selections = $event"
        (selectionsChangeIndex)="selectionChange($event)" [startingIndex]="selectionIndex"></tabs>

    <div *ngIf="selectionIndex == 0" [ngStyle]="{'top': (LoginSettings.InstanceName.length > 0) ? '155px' : '135px'}" class="removePrintAbsolute" style="position:absolute; right:10px; z-index:999; top:135px;">
        <div style="background-color: #8bc34a; height: 22px; width:22px; display: inline-block; vertical-align: middle;">
        </div>
        <span style="padding-left:5px;" translate> = Current Grade (In-Progress, not yet finalized for Report Card)</span>
    </div>

    <div class="flex-content" style="height: 100%;">
        <div #divTraditionalGrades *ngIf="selectionIndex == 0">
            <app-traditional-grades [studentSchedules]="studentSchedules" [studentTerms]="studentTerms"
                [showAssignmentLink]="showAssignmentLink" [showAttendanceLink]="showAttendanceLink"
                [showSendEmailLink]="showSendEmailLink" [isProgressGrades]="isProgressGrades" [isBusy]="isBusy"
                [gradesBehaviorSocialSkills]="gradesBehaviorSocialSkills" [schoolYearSettings]="schoolYearSettings">
            </app-traditional-grades>
        </div>
        <div #divStandardGrades *ngIf="selectionIndex == 1">
            <app-standards-based-grades [studentSchedules]="studentSchedules"
                [studentTermsStandardTab]="studentTermsStandardTab" [showAssignmentLink]="showAssignmentLink"
                [showAttendanceLink]="showAttendanceLink" [showSendEmailLink]="showSendEmailLink"
                [isProgressGrades]="isProgressGrades" [isBusy]="isBusy"
                [gradesBehaviorSocialSkills]="gradesBehaviorSocialSkills" [schoolYearSettings]="schoolYearSettings">
            </app-standards-based-grades>
        </div>
    </div>
</tyl-kendo-pdf-export>
<div class="flex-footer">
    <div class="flex-footer-left">
        <tyl-button #btnExpandAll image="Expand All.png" label="Expand All" (clickEvent)="expandAll(true)"></tyl-button>
        <tyl-button #btnCollapseAll image="Collapse All.png" label="Collapse All" (clickEvent)="expandAll(false)">
        </tyl-button>
        <tyl-button *ngIf="selectionIndex == 1" #btnCodeLegend image="Code Legend.png"
            label="{{selectionIndex==0 ? 'Color Legend': 'Legend'}}" (clickEvent)="legendClick()"></tyl-button>
        <tyl-button *ngIf="selectionIndex == 0 && LoginSettings.V10" image="Code Legend.png" label="Legend"
            (clickEvent)="overrideLegendClick()"></tyl-button>
    </div>
    <div class="flex-footer-middle" style="padding-top:10px;">
        <span style="padding: 5px;" *ngIf="selectionIndex == 0 && isBusy==false" translate>
            Select an underlined grade to see more details.
        </span>
        <span style="padding: 5px;" *ngIf="selectionIndex == 1 && isBusy==false" translate>
            Expand More, then select an underlined term to see more details.
        </span>
    </div>
    <div class="flex-footer-right" style="padding-top:10px;padding-right:10px;">
        <tyl-checkbox [(checked)]="isProgressGrades" (change)="viewProgressGrades()" *ngIf="showProgressGrades">
            <span translate>Show Progress Grades</span>
        </tyl-checkbox>
    </div>
</div>